import { useObserver } from "mobx-react";
import { AiOutlineCheck, AiOutlineCloseCircle } from "react-icons/ai";
import { useStores } from "../../../store";
import { useEffect, useRef, useState } from "react";
import { SlTag } from "react-icons/sl";
import { MdAddCircleOutline, MdOutlineDelete } from "react-icons/md";

const DEFAULT_TAG_COLORS = ["#f97316", "#3b82f6", "#eab308", "#22c55e"];

function normalizeHexColor(input) {
  const s = String(input ?? "").trim();
  if (!s) return null;
  const hex = s.startsWith("#") ? s : `#${s}`;
  if (/^#[0-9A-Fa-f]{6}$/i.test(hex)) return hex.toLowerCase();
  if (/^#[0-9A-Fa-f]{3}$/i.test(hex)) {
    const r = hex[1];
    const g = hex[2];
    const b = hex[3];
    return `#${r}${r}${g}${g}${b}${b}`.toLowerCase();
  }
  return null;
}

export default function LabelPopup(props) {
  const name = useRef();
  const description = useRef();
  const updateName = useRef();
  const updateDescription = useRef();
  const { PopupStore, LabelStore, UserStore } = useStores();
  const colors = DEFAULT_TAG_COLORS;
  const [color, setColor] = useState(
    LabelStore.selectedLableValues?.color || colors[0],
  );
  const [addColorPopoverOpen, setAddColorPopoverOpen] = useState(false);
  const [addColorDraft, setAddColorDraft] = useState(colors[0]);
  const [editColorPopoverOpen, setEditColorPopoverOpen] = useState(false);
  const [editColorDraft, setEditColorDraft] = useState(colors[0]);
  const addCustomColorSectionRef = useRef(null);
  const editCustomColorSectionRef = useRef(null);

  const [addTitleError, setAddTitleError] = useState("");
  const [editTitleError, setEditTitleError] = useState("");

  const EditLabelSubmit = () => {
    const resolved = normalizeHexColor(color) || colors[0];
    const body = {
      name: updateName.current.value.trim(),
      description: updateDescription.current.value,
      color: resolved,
    };
    LabelStore.selectedLableValues.color = resolved;
    LabelStore.UpdateLabel(body).then((res) => {
      if (res) {
        console.log("Label updated");
        LabelStore.fetchLabelsData();
        // props.handleEdit();
      }
    });
    return;
  };

  const submitAddLabel = async () => {
    const title = name.current?.value?.trim() ?? "";
    if (!title) {
      setAddTitleError("Title is required");
      name.current?.focus();
      return;
    }
    setAddTitleError("");
    const resolved = normalizeHexColor(color) || colors[0];
    const body = {
      name: title,
      color: resolved,
      createdBy: UserStore.userDetails?._id,
      description: description.current.value,
    };
    await LabelStore.PostLabel(body);
    // LabelStore.fetchLabelsData();
    PopupStore.setLabelPopup(false);
  };

  const applyAddColorDraft = () => {
    const next = normalizeHexColor(addColorDraft);
    if (!next) return;
    setColor(next);
    setAddColorPopoverOpen(false);
  };

  const applyEditColorDraft = () => {
    const next = normalizeHexColor(editColorDraft);
    if (!next) return;
    setColor(next);
    setEdit(true);
    setEditColorPopoverOpen(false);
  };

  const deleteLabel = () => {
    console.log("delete label");
    LabelStore.deleteLabel(LabelStore.selectedLabel);
    // LabelStore.setLabelRefersher(true);
  };
  useEffect(() => {
    if (PopupStore.labelEditPopup && LabelStore.selectedLableValues) {
      setColor(LabelStore.selectedLableValues?.color || colors[0]);
    }
  }, [PopupStore.labelEditPopup, LabelStore.selectedLableValues, colors]);

  useEffect(() => {
    if (PopupStore.labelPopup) {
      setColor(colors[0]);
      setAddColorPopoverOpen(false);
      setAddTitleError("");
    }
  }, [PopupStore.labelPopup, colors]);

  useEffect(() => {
    if (!PopupStore.labelEditPopup) setEditColorPopoverOpen(false);
  }, [PopupStore.labelEditPopup]);

  useEffect(() => {
    if (PopupStore.labelEditPopup) setEditTitleError("");
  }, [PopupStore.labelEditPopup]);

  useEffect(() => {
    if (!addColorPopoverOpen || !addCustomColorSectionRef.current) return;
    addCustomColorSectionRef.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }, [addColorPopoverOpen]);

  useEffect(() => {
    if (!editColorPopoverOpen || !editCustomColorSectionRef.current) return;
    editCustomColorSectionRef.current.scrollIntoView({
      behavior: "smooth",
      block: "nearest",
    });
  }, [editColorPopoverOpen]);

  const [edit, setEdit] = useState(false);
  return useObserver(() => {
    return (
      <>
        {PopupStore.labelPopup && (
          <div
            className="fixed inset-0 z-50 w-screen h-screen bg-black backdrop-filter backdrop-blur-sm bg-opacity-40"
            onClick={() => {
              PopupStore.setLabelPopup(false);
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="absolute left-1/2 top-1/2 z-50 flex max-h-[90vh] w-[95%] -translate-x-1/2 -translate-y-1/2 flex-col items-center overflow-y-auto rounded-3xl border bg-bg3 px-5 py-6 no-scrollbar md:w-[35%] lg:w-[30%]"
            >
              <AiOutlineCloseCircle
                className="absolute right-2 top-2 z-10 cursor-pointer text-lg text-orange-500"
                onClick={() => {
                  PopupStore.setLabelPopup(false);
                }}
              />

              {/* <h2 className="text-sm font-semibold mt-7 mb-3">Add New Label</h2> */}
              {/* <form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitAddLabel();
                }}
                className="flex flex-col gap-6 items-start mx-auto px-20  h-fit py-5 w-[100%] md:w-[100%] lg:w-[100%]  rounded-xl overflow-y-auto"
              >
                <div className="px-5 py-2 border-2 outline-none flex gap-2 justify-between items-center w-full text-lg rounded-md">
                  <input
                    type="text"
                    ref={name}
                    placeholder="Enter name of the label"
                    className="w-full outline-none "
                  />
                  <input
                    type="color"
                    onChange={(e) => {
                      setColor(e.target.value);
                    }}
                    className="w-6 rounded-3xl h-7 border-none bg-transparent"
                    id="favcolor"
                    name="favcolor"
                    // value={color}
                    ref={Addcolor}
                  ></input>
                </div>

                <button className="py-2 text-sm px-6 font-semibold text-white ml-auto rounded-lg bg-primary ">
                  Add Label
                </button>
              </form> */}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitAddLabel();
                }}
                className="w-[90%]"
              >
                <h2 className="text-lg font-normal mt-7 flex items-center gap-2 mb-2">
                  {" "}
                  <SlTag />
                  Add New Tag
                </h2>
                <div className="mb-4 ">
                  <label
                    className="mb-1 block w-fit font-medium"
                    htmlFor="add-tag-title"
                  >
                    Title <span className="text-red-600">*</span>
                  </label>

                  <input
                    id="add-tag-title"
                    type="text"
                    ref={name}
                    name="title"
                    required
                    aria-required="true"
                    aria-invalid={addTitleError ? "true" : "false"}
                    aria-describedby={
                      addTitleError ? "add-tag-title-error" : undefined
                    }
                    onChange={() => setAddTitleError("")}
                    className={`w-full rounded-md border p-2 text-sm focus:outline-none focus:ring-1 focus:ring-orange-500 ${
                      addTitleError ? "border-red-500" : "border-gray-300"
                    }`}
                    placeholder="Enter the title of the Tag"
                  />
                  {addTitleError ? (
                    <p
                      id="add-tag-title-error"
                      className="mt-1 text-sm text-red-600"
                      role="alert"
                    >
                      {addTitleError}
                    </p>
                  ) : null}
                </div>
                <div className="mb-4">
                  <label className="block w-fit  font-medium mb-1">
                    Description
                  </label>
                  <div className="relative">
                    <textarea
                      ref={description}
                      name="description"
                      maxLength={50}
                      onChange={(e) => {
                        // Using a simple state-less approach or local variable if needed,
                        // but since it's a ref, we can just let maxLength handle the restriction
                        // and add a small visual counter.
                        const count = e.target.value.length;
                        const counter =
                          document.getElementById("add-desc-counter");
                        if (counter) counter.innerText = `${count}/50`;
                      }}
                      className="w-full p-1 border rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-orange-500"
                      placeholder="Add description...."
                      rows="6"
                    />
                    <div
                      id="add-desc-counter"
                      className="absolute bottom-2 right-2 text-[10px] text-gray-400"
                    >
                      0/50
                    </div>
                  </div>
                  <label className="block w-fit font-medium mt-2 ">
                    Add Colour
                  </label>
                  <div className="mb-4 space-y-3">
                    <div className="flex flex-wrap items-center justify-between gap-3 py-1">
                      <div className="flex flex-wrap items-center">
                        {colors?.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="w-5 h-5 ml-1 rounded-2xl border flex items-center justify-center cursor-pointer shrink-0"
                              style={{ backgroundColor: item }}
                              onClick={() => {
                                setColor(item);
                                setAddColorPopoverOpen(false);
                              }}
                            >
                              {item === color && (
                                <AiOutlineCheck className="text-white text-[10px] font-bold" />
                              )}
                            </div>
                          );
                        })}

                        <button
                          type="button"
                          className="relative ml-1 flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center rounded-full border-2 bg-gray-100"
                          style={{
                            backgroundColor:
                              normalizeHexColor(color) || colors[0],
                          }}
                          title={
                            addColorPopoverOpen
                              ? "Hide custom color"
                              : "Custom color"
                          }
                          aria-expanded={addColorPopoverOpen}
                          aria-controls="add-custom-color-panel"
                          onClick={() => {
                            setAddColorDraft(
                              normalizeHexColor(color) || color || colors[0],
                            );
                            setAddColorPopoverOpen((open) => !open);
                          }}
                        >
                          <MdAddCircleOutline className="text-black text-[10px]" />
                        </button>
                      </div>
                      <button
                        type="submit"
                        className="shrink-0 rounded-lg bg-primary px-8 py-2 text-sm font-normal text-white"
                      >
                        Save
                      </button>
                    </div>

                    {addColorPopoverOpen && (
                      <div
                        id="add-custom-color-panel"
                        ref={addCustomColorSectionRef}
                        role="region"
                        aria-label="Custom tag color"
                        className="w-full space-y-3 rounded-xl border border-gray-200 bg-gray-50 p-4"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <p className="text-sm font-medium text-gray-800">
                          Custom color
                        </p>
                        <div
                          className="h-12 w-full rounded-lg border border-gray-200 shadow-inner"
                          style={{
                            backgroundColor:
                              normalizeHexColor(addColorDraft) || "#cccccc",
                          }}
                        />
                        <input
                          type="color"
                          className="h-12 w-full cursor-pointer rounded-lg border border-gray-200 bg-white"
                          value={normalizeHexColor(addColorDraft) || "#888888"}
                          onChange={(e) => setAddColorDraft(e.target.value)}
                        />
                        <input
                          type="text"
                          className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm"
                          value={addColorDraft}
                          onChange={(e) => setAddColorDraft(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              applyAddColorDraft();
                            }
                          }}
                          placeholder="#RRGGBB"
                          aria-label="Hex color"
                        />
                        <div className="flex flex-col gap-2 sm:flex-row">
                          <button
                            type="button"
                            className="flex-1 rounded-lg border border-gray-300 py-2.5 text-sm font-medium text-gray-700"
                            onClick={() => setAddColorPopoverOpen(false)}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="flex-1 rounded-lg bg-primary py-2.5 text-sm font-medium text-white"
                            onClick={applyAddColorDraft}
                          >
                            Apply color
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}{" "}
        {PopupStore.labelEditPopup && (
          <div
            onClick={() => {
              PopupStore.setEditLabelPopup(false);
              setEdit(false);
            }}
            className="fixed inset-0 z-50 w-screen h-screen bg-black backdrop-filter backdrop-blur-sm bg-opacity-40"
          >
            {/* <div
              onClick={(e) => e.stopPropagation()}
              className="absolute  inset-0 bg-bg3 z-50 flex h-fit flex-col justify-center rounded-3xl border  items-center md:w-[35%] lg:w-[30%] w-[90%]  m-auto shadow-lg overflow-y-auto no-scrollbar"
            >
              <AiOutlineCloseCircle
                className="absolute text-xl cursor-pointer top-2 right-2"
                onClick={() => {
                  PopupStore.setEditLabelPopup(false);
                  setEdit(false);
                }}
              />
              <h1 className="text-2xl font-normal mt-9">Edit Label</h1>
              <div className="flex flex-col gap-4 px-20  items-center p-6  mt-3 h-full py-1 w-[100%] md:w-[100%] lg:[100%]  rounded-xl overflow-y-hidden no-scrollbar">
                <div className="px-5 py-3 border-2 outline-none flex gap-2 justify-between items-center w-full text-xl rounded-md">
                  <input
                    type="text"
                    placeholder="Enter name of the label"
                    ref={updateName}
                    defaultValue={LabelStore.selectedLableValues?.name}
                    onChange={() => setEdit(true)}
                    className="w-full outline-none "
                  />

                  <input
                    type="color"
                    ref={Updatecolor}
                    defaultValue={
                      LabelStore.selectedLableValues?.color || color
                    }
                    // value={color}
                    onChange={(e) => {
                      setColor(e.target.value);
                      setEdit(true);
                    }}
                    className="w-6 rounded-3xl h-7 border-none bg-transparent"
                    id="favcolor"
                    name="favcolor"
                  ></input>
                </div>
                <div className="flex w-full justify-between h-fit">
                  <button
                    onClick={() => {
                      deleteLabel();
                      PopupStore.setLabelEditPopup(false);
                      LabelStore.labels_list?.splice(
                        LabelStore.selectedIndex,
                        1
                      );
                      props.handleDelete();
                    }}
                    className=" mt-5 underline text-sm rounded-lg text-red-500 "
                  >
                    Delete
                  </button>
                  <button
                    onClick={() => {
                      EditLabelSubmit();
                      PopupStore.setLabelEditPopup(false);
                    }}
                    className=" mt-5 text-sm text-
                   rounded-lg py-2 px-5 bg-primary "
                  >
                    Update
                  </button>
                </div>
              </div>
            </div> */}
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
              className="absolute left-1/2 top-1/2 z-50 flex max-h-[90vh] w-[95%] -translate-x-1/2 -translate-y-1/2 flex-col items-center overflow-y-auto rounded-3xl border bg-bg3 px-5 py-6 no-scrollbar md:w-[35%] lg:w-[30%]"
            >
              <AiOutlineCloseCircle
                className="absolute right-2 top-2 z-10 cursor-pointer text-lg text-orange-500"
                onClick={() => {
                  PopupStore.setEditLabelPopup(false);
                }}
              />
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  const title = updateName.current?.value?.trim() ?? "";
                  if (!title) {
                    setEditTitleError("Title is required");
                    updateName.current?.focus();
                    return;
                  }
                  setEditTitleError("");
                  EditLabelSubmit();
                  PopupStore.setLabelEditPopup(false);
                }}
                className="w-[90%]"
              >
                <h2 className=" text-lg font-normal mt-7 flex items-center gap-2 mb-2">
                  {" "}
                  <SlTag />
                  Edit Tag
                </h2>
                <div className="mb-4 ">
                  <label
                    className="mb-1 block font-medium"
                    htmlFor="edit-tag-title"
                  >
                    Title <span className="text-red-600">*</span>
                  </label>

                  <input
                    id="edit-tag-title"
                    type="text"
                    placeholder="Enter name of the label"
                    ref={updateName}
                    defaultValue={LabelStore.selectedLableValues?.name}
                    required
                    aria-required="true"
                    aria-invalid={editTitleError ? "true" : "false"}
                    aria-describedby={
                      editTitleError ? "edit-tag-title-error" : undefined
                    }
                    onChange={() => {
                      setEditTitleError("");
                      setEdit(true);
                    }}
                    className={`w-full rounded-md border p-2 focus:outline-none focus:ring-1 focus:ring-orange-500 ${
                      editTitleError ? "border-red-500" : "border-gray-300"
                    }`}
                  />
                  {editTitleError ? (
                    <p
                      id="edit-tag-title-error"
                      className="mt-1 text-sm text-red-600"
                      role="alert"
                    >
                      {editTitleError}
                    </p>
                  ) : null}
                </div>
                <div className="mb-4">
                  <label className="block font-medium mb-1">Description</label>
                  <div className="relative">
                    <textarea
                      ref={updateDescription}
                      defaultValue={LabelStore.selectedLableValues?.description}
                      maxLength={50}
                      onChange={(e) => {
                        const count = e.target.value.length;
                        const counter =
                          document.getElementById("edit-desc-counter");
                        if (counter) counter.innerText = `${count}/50`;
                      }}
                      name="description"
                      className="w-full p-1 border rounded-lg text-sm focus:outline-none focus:ring-1 focus:ring-orange-500"
                      placeholder="Add description...."
                      rows="6"
                    />
                    <div
                      id="edit-desc-counter"
                      className="absolute bottom-2 right-2 text-[10px] text-gray-400"
                    >
                      {LabelStore.selectedLableValues?.description?.length || 0}
                      /50
                    </div>
                  </div>
                  <label className="block  font-medium mt-2 ">Add Colour</label>
                  <div className="mb-4 space-y-3">
                    <div className="flex flex-wrap items-center justify-between gap-3 py-1">
                      <div className="flex flex-wrap items-center gap-1">
                        {colors?.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="w-5 h-5 ml-1 rounded-2xl border flex items-center justify-center cursor-pointer shrink-0"
                              style={{ backgroundColor: item }}
                              onClick={() => {
                                setColor(item);
                                setEdit(true);
                                setEditColorPopoverOpen(false);
                              }}
                            >
                              {item === color && (
                                <AiOutlineCheck className="text-white text-[10px] font-bold" />
                              )}
                            </div>
                          );
                        })}

                        <button
                          type="button"
                          className="relative ml-1 flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center rounded-full border-2 bg-gray-100"
                          style={{
                            backgroundColor:
                              normalizeHexColor(color) || colors[0],
                          }}
                          title={
                            editColorPopoverOpen
                              ? "Hide custom color"
                              : "Custom color"
                          }
                          aria-expanded={editColorPopoverOpen}
                          aria-controls="edit-custom-color-panel"
                          onClick={() => {
                            setEditColorDraft(
                              normalizeHexColor(color) || color || colors[0],
                            );
                            setEditColorPopoverOpen((open) => !open);
                          }}
                        >
                          <MdAddCircleOutline className="text-black text-[10px]" />
                        </button>
                      </div>
                      <div className="flex shrink-0 items-center gap-2">
                        <button
                          type="submit"
                          className="rounded-lg bg-primary px-8 py-2 text-sm font-normal text-white"
                        >
                          Update
                        </button>
                        <MdOutlineDelete
                          className="cursor-pointer text-2xl"
                          onClick={() => {
                            deleteLabel();
                            PopupStore.setLabelEditPopup(false);
                          }}
                        />
                      </div>
                    </div>

                    {editColorPopoverOpen && (
                      <div
                        id="edit-custom-color-panel"
                        ref={editCustomColorSectionRef}
                        role="region"
                        aria-label="Custom tag color"
                        className="w-full space-y-3 rounded-xl border border-gray-200 bg-gray-50 p-4"
                        onClick={(e) => e.stopPropagation()}
                      >
                        <p className="text-sm font-medium text-gray-800">
                          Custom color
                        </p>
                        <div
                          className="h-12 w-full rounded-lg border border-gray-200 shadow-inner"
                          style={{
                            backgroundColor:
                              normalizeHexColor(editColorDraft) || "#cccccc",
                          }}
                        />
                        <input
                          type="color"
                          className="h-12 w-full cursor-pointer rounded-lg border border-gray-200 bg-white"
                          value={normalizeHexColor(editColorDraft) || "#888888"}
                          onChange={(e) => setEditColorDraft(e.target.value)}
                        />
                        <input
                          type="text"
                          className="w-full rounded-lg border border-gray-200 px-3 py-2 text-sm"
                          value={editColorDraft}
                          onChange={(e) => setEditColorDraft(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              applyEditColorDraft();
                            }
                          }}
                          placeholder="#RRGGBB"
                          aria-label="Hex color"
                        />
                        <div className="flex flex-col gap-2 sm:flex-row">
                          <button
                            type="button"
                            className="flex-1 rounded-lg border border-gray-300 py-2.5 text-sm font-medium text-gray-700"
                            onClick={() => setEditColorPopoverOpen(false)}
                          >
                            Cancel
                          </button>
                          <button
                            type="button"
                            className="flex-1 rounded-lg bg-primary py-2.5 text-sm font-medium text-white"
                            onClick={applyEditColorDraft}
                          >
                            Apply color
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </>
    );
  });
}
